import React from "react";
// import '../../pages/Home.css'

const Header = () => {

    return (

        <>

            <header >

                <div>
                    <h1>Header</h1>
                </div>

            </header>

        </>



    )

}

export default Header;